import { createSelector } from 'reselect'

export const selectCommunicationBoardState = state => state.communicationBoardTools

export const selectCommunicationBoardSection = createSelector(
  selectCommunicationBoardState,
  data => data.section
)

export const selectCommunicationBoardContent = createSelector(
  selectCommunicationBoardState,
  data => data.content
)

export const selectCommunicationBoardStoreData = createSelector(
  selectCommunicationBoardState,
  data => ({
    section: data.section,
    content: data.content,
    isLoading: Boolean(data.isLoading),
    isSaving: Boolean(data.isSaving),
    resultError: data.resultError,
    resultMessage: data.resultMessage,
  })
)
